"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchBar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _styles = require("@material-ui/core/styles");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  input: {
    width: '100%',
    height: 24
  },
  search: {
    border: `1px solid ${theme.palette.action.disabled}`,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    height: 36,
    paddingRight: 10,
    transition: 'all .3s',
    '&:hover': {
      border: `1px solid ${theme.palette.text.primary}`
    }
  },
  searchActive: {
    border: `2px solid ${theme.palette.primary.main}`,
    '&:hover': {
      border: `2px solid ${theme.palette.primary.main}`
    }
  },
  icons: {
    margin: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  searchIcon: {
    verticalAlign: 'middle'
  }
}));
const SearchBar = _ref => {
  let {
    placeholder,
    onSubmit,
    size,
    value,
    onChange,
    clearSearch,
    goBackSearch,
    onClickOustide,
    showBackArrow
  } = _ref;
  const classes = useStyles();
  const [clicked, setClicked] = (0, _react.useState)(false);
  const handleClassActive = () => {
    setClicked(!clicked);
  };

  // Função padrao para realizar a busca de livros na BDS
  // const handleSearch = (value) => {
  //   if (value.length > 0) {
  //     history.push(`/books?query=${value}`)
  //   }
  // }

  return /*#__PURE__*/_react.default.createElement("form", {
    onBlur: onClickOustide,
    size: size,
    style: {
      width: (0, _utils.checkSize)(size)
    },
    className: clicked ? ` ${classes.search} ${classes.searchActive}` : classes.search,
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.icons
  }, value.length || showBackArrow ? /*#__PURE__*/_react.default.createElement(_ArrowBack.default, {
    onClick: goBackSearch,
    className: classes.icon
  }) : /*#__PURE__*/_react.default.createElement(_Search.default, {
    className: classes.searchIcon
  })), /*#__PURE__*/_react.default.createElement(_InputBase.default, {
    value: value,
    placeholder: placeholder,
    className: classes.input,
    onClick: handleClassActive,
    onBlur: handleClassActive,
    onChange: onChange
  }), value.length > 0 && /*#__PURE__*/_react.default.createElement(_Close.default, {
    onClick: clearSearch,
    className: classes.icon,
    style: {
      fontSize: 16
    }
  }));
};
exports.SearchBar = SearchBar;
SearchBar.propTypes = {
  /**
   * Escolhe o texto da barra de pesquisa
   */
  placeholder: _propTypes.default.string,
  /**
   * Função a ser executada ao realizar a busca do input
   */
  onSubmit: _propTypes.default.func,
  /**
   * Seleciona o tamanho do input
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),
  /**
   * Valor do input
   */
  value: _propTypes.default.string,
  /**
   * Funcao ao mudar o valor
   */
  onChange: _propTypes.default.func,
  /**
   * Funcao para excluir a pesquisa
   */
  clearSearch: _propTypes.default.func.isRequired,
  /**
   * Funcao realizada ao clicar no botao de voltar
   */
  goBackSearch: _propTypes.default.func.isRequired,
  /**
   * Funcao realizada ao clicar fora do componente
   */
  onClickOustide: _propTypes.default.func,
  /**
   * Ativa Back Arrow mesmo sem preencher o campo de pesquisa
   */
  showBackArrow: _propTypes.default.bool
};
SearchBar.defaultProps = {
  placeholder: 'Buscar por título, autor ou ISBN',
  onSubmit: null,
  size: 'md',
  value: '',
  onChange: null,
  onClickOustide: null,
  showBackArrow: false
};
var _default = exports.default = SearchBar;